var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "div",
        { staticClass: "builder-bottom-right" },
        [
          _c("router-link", {
            attrs: { to: _vm.nextTabLink },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var navigate = ref.navigate
                  return [
                    _c(
                      "Button",
                      {
                        nativeOn: {
                          click: function($event) {
                            return navigate($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resource("Button_Next")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default", null, { tabId: _vm.currentTabId }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "builder-bottom-right" },
        [
          _c("router-link", {
            attrs: { to: _vm.nextTabLink },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var navigate = ref.navigate
                  return [
                    _c(
                      "Button",
                      {
                        nativeOn: {
                          click: function($event) {
                            return navigate($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.resource("Button_Next")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }